module.exports = fox._r("images/cb-feedback-white.png", __webpack_public_path__ + "_/_/_/root/images/cb-feedback-white.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/cb-feedback-white.png
// module id = 978
// module chunks = 4